import React from "react";
import QPhototModuleSubtopic from "../../../QPhotoModuleSubtopic";

const SurfaceIntegral = () => (
  <QPhototModuleSubtopic
    title="Surface integral"
    videos={[
      "https://www.youtube.com/embed/DMsmIMJSF1w"
    ]}
    takeaways={[]}
    questions={[
        {
            image:"/cal_77.jpeg"
        }
    ]}
    exampleVideos={[]}
  />
);

export default SurfaceIntegral;
